import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { SearchResultTab } from './search-result-tab.component';

import { SearchSkeletonRows } from '@/app/(main)/_components/search-modal/_components/loadings/search-skeleton-loading.component';
import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { Typography } from '@/components/ui/typography/typography.component';
import { useFeaturedMostSearchedProcedures } from '@/hooks/use-most-searched.hook';
import { SearchModalListEnum } from '@/types/enums/analytics/home/home-analytics.enum';
import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';

const LOADING_ROWS = 5;

interface MostSearchedProps {
  setOpen: (open: boolean) => void;
  selectLaboratoryProcedure?: (procedure: SelectedProcedures) => void;
  locationOverride?: OverridedUserLocation;
}

export const MostSearched = ({ setOpen, selectLaboratoryProcedure, locationOverride }: MostSearchedProps) => {
  const { procedures: mostSearchedProcedures, isLoading } = useFeaturedMostSearchedProcedures();

  if (isLoading) {
    return (
      <div data-testid={DataTestIdEnum.PROCEDURES_MODAL_MOST_SEARCHED_LOADING} className="px-6">
        <SearchSkeletonRows rows={LOADING_ROWS} />
      </div>
    );
  }

  if (mostSearchedProcedures.length === 0) {
    return null;
  }

  return (
    <div data-testid={DataTestIdEnum.PROCEDURES_MODAL_MOST_SEARCHED}>
      <Typography className="font-semibold px-6">
        Mais procurados
      </Typography>
      <div>
        {mostSearchedProcedures.map((procedure, index) => (
          <div key={procedure.id} className="hover:bg-gray-50 transition-colors">
            <SearchResultTab
              {...procedure}
              list={SearchModalListEnum.MOST_SEARCHED}
              position={index + 1}
              totalResults={mostSearchedProcedures.length}
              setOpen={setOpen}
              selectLaboratoryProcedure={selectLaboratoryProcedure}
              locationOverride={locationOverride}
            />
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};
